import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./MainHeader.module.scss";

export default function MainHeader({ title, showProgress, percent }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleBackNavigation = () => {
    switch (pathname) {
      case "/withdraw-history":
        navigate("/");
        break;

      default:
        navigate("/");
    }
  };

  return (
    <>
      <div className={styles.main__header}>
        <div className={styles.header_inner}>
          <div className={styles.back_button} onClick={() => handleBackNavigation()}>
            <img src="/images/back_icon.svg" className={styles.back_icon} />
          </div>
          <h1 className={styles.header_title}>{title}</h1>
        </div>

        {showProgress && (
          <div className={styles.header_progress}>
            <div className="text">{percent}%</div>
            <div className={styles.progress_bar}>
              <div className={styles.progress_completed} style={{ width: `${percent}%` }}></div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
